export const COMMON_PATHS = {
  환급랜딩: '/',
  양도세환급랜딩: '/capital-gain',
  개인법인선택: `/tax/refund/select-service`,
  환급조회목록: `/tax/refund/summary`,
  환급금입금방법: `/tax/refund/result/manual`,
  환급자주묻는질문: '/help/faq',
  환급결정확인알림톡: '/trr',
  MORE_MENU: '/menu',
  환급계좌입력: `/tax/refund/bank-account`,
  환급결제카드등록: `/tax/refund/payment-card`,
  환급결제카드입력: `/tax/refund/payment-card/input`,
  환급본인휴대폰번호입력: '/tax/refund/phone-number',
  간편인증_정보입력: '/tax/refund/simple-auth/input',
  간편인증_인증확인: '/tax/refund/simple-auth/confirm',
  수집_진행중: '/tax/refund/collect/in-progress',
  수집_완료: '/tax/refund/collect/completed',
  환급신청완료: `/tax/refund/apply/complete`,
  환급신청결과: `/tax/refund/apply/result`,
  조회완료재현: '/tax/refund/lookup/reenactment',
  환급신청재현: '/tax/refund/apply/reenactment',
  위임장서명: '/tax/refund/power-of-attorney/sign',
  위임장제출: '/tax/refund/power-of-attorney/submit',
  위임장미리보기: '/tax/refund/power-of-attorney/preview',
  조회대기열: '/tax/refund/lookup/queue'
};

export const AUTH_PATHS = {
  로그인: '/auth/sign-in',
  회원가입입력: '/auth/sign-up/input',
  회원가입약관동의: '/auth/sign-up/terms',
  로그아웃: '/auth/sign-out',
  패스워드찾기: '/auth/forgot-password',
  패스워드재설정: '/auth/reset-password',
  CI인증처리: `/auth/ci-authentication`,
  CI수집요청: `/auth/ci-request`,
  회원탈퇴사유: `/auth/withdraw/reason`,
  회원탈퇴확인: `/auth/withdraw/confirm`
};

export const ERROR_PAGE_PATHS = {
  로그인필요: '/error/unauthorized',
  홈택스이용불가시간: '/error/hometax/unavailable-time',
  홈택스과부하제어시간: '/error/hometax/overload-control'
};

export const INDIVIDUAL_PATHS = {
  개인조회방법선택: `/tax/refund/individual/select-auth`,
  개인공동인증서프로그램설치판단: `/tax/refund/individual/joint-certificate/install`,
  개인공동인증서선택: `/tax/refund/individual/joint-certificate/select`,
  개인수집및조회: `/tax/refund/lookup/request`,
  개인환급액조회결과: `/tax/refund/lookup/result`,
  개인홈택스이용불가시간: `/tax/refund/individual/lookup/error/hometax-impossible`,
  개인홈택스점검중: `/tax/refund/individual/lookup/error/hometax-server-fix`,
  개인재로그인유도: `/tax/refund/individual/lookup/error/hometax-session`,
  개인홈택스수집지연: `/tax/refund/individual/lookup/error/hometax-timeout`,
  개인일시적인오류: `/tax/refund/individual/lookup/error/temporary`,
  개인기타오류: `/tax/refund/individual/lookup/error/hometax-etc`,
  개인신고내역없음: `/tax/refund/individual/lookup/error/hometax-no-bman`,
  개인취소방어: `/tax/refund/individual/cancel`,
  개인취소사유: `/tax/refund/individual/cancel/reason`
};

export const CORPORATION_PATHS = {
  법인조회방법선택: `/tax/refund/corporation/select-auth`,
  홈택스아이디입력: `/tax/refund/corporation/hometax-auth`,
  법인공동인증서프로그램설치판단: `/tax/refund/corporation/joint-certificate/install`,
  법인공동인증서선택: `/tax/refund/corporation/joint-certificate/select`,
  법인수집및조회: `/tax/refund/lookup/request`,
  법인환급액조회결과: `/tax/refund/lookup/result`,
  법인홈택스이용불가시간: `/tax/refund/corporation/lookup/error/hometax-impossible`,
  법인홈택스점검중: `/tax/refund/corporation/lookup/error/hometax-server-fix`,
  법인재로그인유도: `/tax/refund/corporation/lookup/error/hometax-session`,
  법인홈택스수집지연: `/tax/refund/corporation/lookup/error/hometax-timeout`,
  법인일시적인오류: `/tax/refund/corporation/lookup/error/temporary`,
  법인기타오류: `/tax/refund/corporation/lookup/error/hometax-etc`,
  법인취소방어: `/tax/refund/corporation/cancel`,
  법인취소사유: `/tax/refund/corporation/cancel/reason`
};

export const 환급결정확인알림톡_PATH = {
  환급불가: `/tax/refund/result/impossible`,
  환급결정내역있음: `/tax/refund/result/success`,
  환급결정내역없음: `/tax/refund/result/wait`,
  공동인증서설치판단: `/tax/refund/result/joint-certificate/install`,
  공동인증서선택: `/tax/refund/result/joint-certificate/select`,
  환급결정로딩: `/tax/refund/result/request`,
  환급결정로딩에러기타: `/tax/refund/result/request/error/etc`,
  환급결정로딩에러TIN비일치: `/tax/refund/result/request/error/not-equal-tin`,
  환급결정로딩에러홈택스: `/tax/refund/result/request/error/hometax`
};

export const DECISION_PATHS = {
  결정확인방법선택: `/tax/refund/individual/decision/select-auth`,
  공동인증서설치판단: `/tax/refund/individual/decision/joint-certificate/install`,
  공동인증서선택: `/tax/refund/individual/decision/joint-certificate/select`,
  환급결정로딩: `/tax/refund/individual/decision/request`,
  환급결정내역있음: `/tax/refund/individual/decision/result/accept`,
  환급결정내역없음: `/tax/refund/individual/decision/result/none`,
  에러동일TIN: `/tax/refund/individual/decision/error/equal-tin`,
  에러기타: `/tax/refund/individual/decision/error/etc`
};

export const SIMPLE_TERMS_PATHS = {
  토큰유효시간만료: `/simple/timeout`,
  개인신청성공: `/simple/indis/apply/success`,
  법인신청성공: `/simple/corps/apply/success`
};

export const MY_PAGE_PATHS = {
  내정보: `/my`,
  알림설정: `/my/notification`,
  약관및정책: `/my/terms`,
  환급받은내역: `/my/refund-history`,
  탈퇴불가: `/my/unable-to-leave`
};

export const SURVEY_PAGES = {
  설문시작: '/survey/start',
  intro: '/survey/intro',
  설문완료: '/survey/completed',
  만료: '/survey/expired',
  사업장별질문: '/survey/home',
  인적공제_간편인증필요: '/survey/personal-deduction',

  // 고용증대/사회보험료 질문
  대표특관자: '/survey/employment/special-relationships',
  대표특관자_과거: '/survey/employment/special-relationships/past-to-currently',
  대표특관자_현재: '/survey/employment/special-relationships/currently',
  근로계약서: '/survey/employment/contracts',

  // 창중감 질문
  직업창업: '/survey/business/start-business',
  // small-boss or machine-owner
  소사장제지입사: '/survey/business/small-boss-machine-owner',
  새간판: '/survey/business/signboard',
  공동사업자: '/survey/business/partner',
  승계직원: '/survey/business/takeover-employee',
  동종업종_사업여부: '/survey/business/same-industry-before',
  사업장_근무여부: '/survey/business/work-location-check',
  주소이전_현재주소_질문: '/survey/business/first-location/is-original',
  주소이전_현재주소_이전연도: '/survey/business/first-location/move-year',
  주소이전_홈: '/survey/business/first-location/all-locations',
  주소이전_추가수정: '/survey/business/first-location/form',
  사업장_자가구매: '/survey/business/office-type'
};
